import { render, staticRenderFns } from "./createAccountModal.vue?vue&type=template&id=6e824b6c&scoped=true"
import script from "./createAccountModal.vue?vue&type=script&lang=js"
export * from "./createAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e824b6c",
  null
  
)

export default component.exports